import { useCallback } from "react";
import { API } from "aws-amplify";
import { credentials as credentialsGqlMutation } from "../../graphql/mutations";
import { GraphQLQuery } from "@aws-amplify/api";
import { CredentialsMutation, Credentials, CredentialsInput } from "../../API";

export function useCredentials() {
    console.log("useCredentials");
    const authCredentials = useCallback(
        async (
            input: CredentialsInput
        ): // input: CreatePaymentInput
        Promise<Partial<Credentials | null>> => {
            // console.log("[authCredentials]", input);
            const result = await API.graphql<GraphQLQuery<CredentialsMutation>>(
                {
                    query: credentialsGqlMutation,
                    variables: { input },
                }
            );

            return result.data?.credentials || null;
        },
        []
    );

    return { authCredentials };
}
